import React, {  FC } from 'react'
import t from '../../../translations/main'

import MainDatePicker from './MainDatePicker'
import { DatePickerProps } from './types'

const DatePicker: FC<DatePickerProps> = props => {
  return (
    <MainDatePicker {...props} />
  )
}

DatePicker.defaultProps = {
  // @ts-ignore:next-line
  labels: t('components.datePicker',  { returnObjects: true }),
}

export default DatePicker
